class StreamedEvents {
  constructor(view, streamedEventsEl) {
    this.view = view;

    this.streamedEventsEl = streamedEventsEl;

    this.configureElements();
  }

  configureElements() {
    this.streamedEventsEl.select2nonUnique({
      placeholder: 'Number of services',
      minimumResultsForSearch: Infinity
    });
  }

  static updateLabels(currentBtn, streamedEvents, recordingOption) {
    const currentRow = currentBtn.parent().parent();
    const infoMasterServices = currentRow.find('.info_streamed_events');
    const infoReprintServices = currentRow.find('.info_reprint_services');
    const servicesLabel = currentRow.find('.services_label');
    const divider = currentRow.find('.divider');

    if (reprintNumServices > 0) {
      infoReprintServices.parent().show();
      infoReprintServices.html(reprintNumServices);
    } else {
      infoReprintServices.parent().hide();
    }

    if (masterNumServices > 0) {
      infoMasterServices.parent().show();
      infoMasterServices.html(masterNumServices);
    } else {
      infoMasterServices.parent().hide();
    }

    if (reprintNumServices > 0 && masterNumServices > 0) {
      divider.show();
    } else {
      divider.hide();
    }

    servicesLabel.html(streamedEvents > 1 ? ' Streamed Events' : ' Streamed Event');

    currentBtn.data('streamed-events', streamedEvents);
    currentBtn.data('recording-option', recordingOption);
  }
}

module.exports = StreamedEvents;
